// extracted by mini-css-extract-plugin
export default {"root":"Layout_root__SLY+s","container":"Layout_container__Kdom4"};